import { BLEND_MODES, Container } from "pixi.js";
import { Sequence } from "@nolimitcity/slot-game/bin/core/displayobject/Sequence";
import { ReelSpriteSymbolArea } from "@nolimitcity/slot-game/bin/core/engines/reel/symbol/ReelSpriteSymbolArea";
import { StageManager } from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import { GameResources } from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import { PunkGameConfig } from "../PunkGameConfig";


interface PunkSymbolLayerConfig{
    layerName:string;
    zIndex:number;
    texturePath:string;
}

export class PunkSymbolLayerType{
    public static readonly POO:string = "Poo";
    public static readonly SPARK:string = "Spark";
    public static readonly IGNITE:string = "WildIgnite";
    public static readonly FIRE:string = "WildFire";
    public static readonly IDLE:string = "WildIdle";
    public static readonly SPIN:string = "WildFireSpin";

    public static layerConfig(state:string):PunkSymbolLayerConfig{
        return {layerName:this.layerDefined(state), zIndex:this.zDefinition(state), texturePath:state };
    }

    protected static zDefinition(state:string):number{
        switch(state){
            case this.FIRE:
                return 1;
            case this.IGNITE:
                return 2;
            case this.IDLE:
                return 3;
            case this.SPIN:
            case this.SPARK:
                return 4;
            default:
                return 0;
        }
    }

    public static yOffset(state:string):number{
        if(state == PunkSymbolLayerType.SPIN || state == PunkSymbolLayerType.SPARK){
            return 75;
        }
        return 0;
    }

    protected static layerDefined(state:string):string{
        switch(state){
            default:
                return PunkGameConfig.instance.LAYERS.SYMBOL_OVERLAY.name;
        }
    }
}

export class PunkSymbolLayer {
    protected animations:Sequence[] = [];
    protected symbolLinked:ReelSpriteSymbolArea;
    protected textureSprite?:PIXI.Sprite;

    constructor(symbol:ReelSpriteSymbolArea){
        this.symbolLinked = symbol;
    }
   
    public remove():void{
        const cont:Container = StageManager.getLayer(PunkGameConfig.instance.LAYERS.SYMBOL_OVERLAY.name);
        for(let i:number = 0; i < this.animations.length;i++){
            this.animations[i].reset(false);
            let indx:number = cont.getChildIndex(this.animations[i])
            cont.removeChildAt(indx);
            delete this.animations[i];
        }
        this.animations = [];
        if(this.textureSprite){
            let indx:number = cont.getChildIndex(this.textureSprite)
            cont.removeChildAt(indx);
            delete this.textureSprite;
        } 
    }

    public fetchSequence(state:string):Sequence{
        let config:PunkSymbolLayerConfig = PunkSymbolLayerType.layerConfig(state);
        const cont:Container = StageManager.getLayer(config.layerName);

        for(let i:number = 0; i < this.animations.length;i++){
            if(this.animations[i].name == config.texturePath) return this.animations[i];
        }

        const seq:Sequence = this.getItem(config.texturePath);
        seq.zIndex = config.zIndex;
        seq.pivot.set(0, PunkSymbolLayerType.yOffset(state));
        cont.addChild(seq);
        cont.sortChildren();
        return seq;
    }

    protected getItem(texturePath:string):Sequence{
        let seq:Sequence = new Sequence({ textures: GameResources.getTextures(texturePath) });
        seq.alpha = 0;
        seq.blendMode = BLEND_MODES.ADD;
        seq.anchor.set(0.5,0.5);
        seq.name = texturePath;
        this.animations.push(seq);
        return seq;
    }
}